export const LOGO: string = '/assets/images/mentalplus-logo.png';
export const MINI_LOGO: string = '/assets/images/mentalpluslogo.png';

export const ICON_SHIELD_CHECKMARK: string = '/assets/icon/shieldCheckmark.png';

// --- Mountain (gamified) home experience: landscape art ---
export const MOUNTAIN: string = '/assets/images/landscapes/mountain.png';
export const SUN: string = '/assets/images/landscapes/sun.png';
export const EAGLE: string = '/assets/images/landscapes/eagle.png';
export const RAINBOW: string = '/assets/images/landscapes/rainbow.png';
export const FLOWERS: string = '/assets/images/landscapes/flowers.png';
export const ANIMALS: string = '/assets/images/landscapes/animals.png';
export const GREENERY: string = '/assets/images/landscapes/greenery.png';
export const FIREWORKS: string = '/assets/images/landscapes/firework.png';
export const NIGHT: string = '/assets/images/landscapes/night.png';
export const VICTORY_HIKER: string = '/assets/images/landscapes/victory_hiker.png';
export const ROAD: string = '/assets/images/landscapes/road.png';
export const HIKER: string = '/assets/images/landscapes/hiker.png';
export const FIREWORK: string = '/assets/icon/firework.png';

// --- Invitation feature (unrouted today, kept for future use) ---
export const EMAIL: string = '/assets/images/social/email.png';
export const LINK: string = '/assets/images/social/link.png';
export const SMS: string = '/assets/images/social/sms.png';
export const INSTAGRAM: string = '/assets/images/social/instagram.png';
export const WHATSAPP: string = '/assets/images/social/whatsapp.png';
export const SNAPCHAT: string = '/assets/images/social/snapchat.png';
export const TWITTER: string = '/assets/images/social/twitter.png';
export const MESSENGER: string = '/assets/images/social/messenger.png';

// --- Landing-page partner logos ---
export const LOGOECEVE: string = '/assets/images/logo_eceve.png';
export const LOGOPARISUNI: string = '/assets/images/logo_paris_uni.png';
export const LOGOSANTE: string = '/assets/images/Logo_Paris-Saclay.svg';
export const LOGORECHERCHE: string = '/assets/images/epsm.jpg';
export const LOGOINSERM: string = '/assets/images/logo_inserm.png';
